import {Button, Modal} from "antd";
import style from "./styles/PeriodicExpensesCard.module.css";
import React from "react";


const PaymentsByCategory = ({setIsModalVisible, data, formatCurrency, isModalVisible = isModalVisible}) => {

    console.log(data);


    return (
        <div>
            <Button
                type="link"
                onClick={() => setIsModalVisible(true)}
                className={style.showCategoriesBtn}
            >
                Платежи по категориям
            </Button>

            <Modal
                title={`Платежи по категориям (${data.by_category.length})`}
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                width={550}
                footer={[
                    <div key="footer" style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                        <div>
                            <div style={{fontSize: '12px', color: '#666'}}>Общая сумма:</div>
                            <div style={{fontSize: '16px', fontWeight: '600', color: '#1890ff'}}>
                                {formatCurrency(data.total)}
                            </div>
                        </div>
                        <Button
                            onClick={() => setIsModalVisible(false)}
                            type="primary"
                        >
                            Закрыть
                        </Button>
                    </div>
                ]}
            >
                <div style={{maxHeight: '500px', overflowY: 'auto'}}>
                    {data.by_category.map((category) => (
                        <div
                            key={category.id}
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '6px 0',
                                borderBottom: '1px solid #f0f0f0'
                            }}
                        >
                            <div>
                                <div style={{fontWeight: '500', marginBottom: '4px'}}>
                                    {category.name}
                                </div>
                                <div style={{fontSize: '12px', color: '#666'}}>
                                    {category.count} платеж(а)
                                </div>
                            </div>
                            <div style={{textAlign: 'right'}}>
                                <div style={{fontWeight: '600', color: '#1890ff', fontSize: '16px'}}>
                                    {formatCurrency(category.total)}
                                </div>
                                <div style={{fontSize: '12px', color: '#666', marginTop: '4px'}}>
                                    {((category.total / data.total) * 100).toFixed(1)}%
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Modal>
        </div>
    )
}

export default PaymentsByCategory;